<template>
  <div class="ccui-home-index">
    <div
      class="ccui-app-container-auto tableList"
      ref="purchaseDaily"
      v-show="bidOpeningFlag == '0'"
    >
      <div
        class="ccui-advanced-search-wrapper ccui-clearfix"
        ref="advancedSearchWrapper"
      ></div>
      <div
        class="ccui-multifunctional-table-wrapper"
        style="position: relative"
        v-loading="loading"
      >
        <el-search
          :formProp="formData"
          @search="search"
          :isShow="isShow"
          class="ccui-highsearch"
          :selectClear="true"
          width="460px"
          @resetForm="resetForm"
          :key="isActive"
        >
          <div class="ccui-tab-wrapper">
            <el-button
              :type="isActive === index ? 'table-top-active' : 'table-top'"
              size="mini"
              v-for="(item, index) in evaStatusOptions"
              :key="index"
              @click="tabChange(item.dicKey, index)"
            >
              <template v-if="item.dicKey === '2' && totalNum !== null"
                >评标中{{ isActive === 0 ? `(${totalNum})` : "" }}</template
              >
              <template v-if="item.dicKey === '3' && totalNum !== null"
                >评标结束{{ isActive === 1 ? `(${totalNum})` : "" }}</template
              >
              <template v-if="item.dicKey === '4' && totalNum !== null"
                >标书开启{{ isActive === 2 ? `(${totalNum})` : "" }}</template
              >
            </el-button>
          </div>
          <template slot="search">
            <el-input
              v-model="formData.schemeCode"
              clearable
              searchLabel="方案编号"
              placeholder="请输入方案编号模糊查询"
            ></el-input>
            <el-input
              v-model="formData.schemeName"
              clearable
              searchLabel="方案名称"
              placeholder="请输入方案名称模糊查询"
            ></el-input>
            <el-input
              v-if="isActive !== 2"
              v-model="formData.evaRoomName"
              clearable
              searchLabel="评标室"
              placeholder="请输入评标室模糊查询"
            ></el-input>
            <el-input
              v-if="isActive !== 2"
              v-model="formData.purchaseUnder"
              readonly
              @focus="showPurchaseUnder"
              searchLabel="承办人"
              placeholder="请选择承办人查询"
            ></el-input>
            <el-date-picker
              v-if="isActive !== 2"
              searchLabel="评标时间"
              v-model="formData.time"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <!--            <el-select-->
            <!--              v-model="formData.evaStatus"-->
            <!--              clearable-->
            <!--              searchLabel="评标状态"-->
            <!--              placeholder="请选择评标状态查询"-->
            <!--            >-->
            <!--              <el-option-->
            <!--                v-for="item in evaStatusOptions"-->
            <!--                :key="item.dicKey"-->
            <!--                :label="item.dicValue"-->
            <!--                :value="item.dicKey"-->
            <!--              ></el-option>-->
            <!--            </el-select>-->
          </template>
          <!-- 表单高级搜索 -->
          <el-input
            v-model="formData.schemeCode"
            slot="searchItem1"
            clearable
            searchLabel="方案编号"
            placeholder="请输入方案编号模糊查询"
          ></el-input>
          <el-input
            v-model="formData.schemeName"
            slot="searchItem2"
            clearable
            searchLabel="方案名称"
            placeholder="请输入方案名称模糊查询"
          ></el-input>
          <el-input
            v-if="isActive !== 2"
            v-model="formData.evaRoomName"
            slot="searchItem3"
            clearable
            searchLabel="评标室"
            placeholder="请输入评标室模糊查询"
          ></el-input>
          <el-input
            v-if="isActive !== 2"
            v-model="formData.purchaseUnder"
            readonly
            @focus="showPurchaseUnder"
            slot="searchItem4"
            searchLabel="承办人"
            placeholder="请选择承办人查询"
          ></el-input>
          <el-date-picker
            v-if="isActive !== 2"
            searchLabel="评标时间"
            slot="searchItem5"
            v-model="formData.time"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <!--          <el-select-->
          <!--            slot="searchItem6"-->
          <!--            v-model="formData.evaStatus"-->
          <!--            clearable-->
          <!--            searchLabel="评标状态"-->
          <!--            placeholder="请选择评标状态查询"-->
          <!--          >-->
          <!--            <el-option-->
          <!--              v-for="item in evaStatusOptions"-->
          <!--              :key="item.dicKey"-->
          <!--              :label="item.dicValue"-->
          <!--              :value="item.dicKey"-->
          <!--            ></el-option>-->
          <!--          </el-select>-->
        </el-search>
        <template v-if="isActive == 0">
          <div v-if="evaluationTableData.length > 0">
            <div class="module-content">
              <template v-for="(pItem, pIndex) in evaluationTableData">
                <div class="module-content-row" :key="pIndex">
                  <template v-for="(item, index) in flist(pItem, colnum, null)">
                    <div
                      v-if="item"
                      class="module-content-col"
                      :key="`${index}-${pIndex}`"
                    >
                      <template v-if="item.evaRoomName.length > 41">
                        <el-tooltip
                          class="item"
                          :content="item.evaRoomName"
                          placement="top"
                        >
                          <div class="module-content-title">
                            {{ item.evaRoomName }}
                          </div>
                        </el-tooltip>
                      </template>
                      <template v-else>
                        <div class="module-content-title">
                          {{ item.evaRoomName }}
                        </div>
                      </template>
                      <div class="module-content-project">
                        {{ item.evaPurStep }}
                      </div>
                      <div class="module-content-time">
                        <svg-icon icon-class="time" class-name="svg-time" />
                        {{
                          moment(item.evaStartTime).format("YYYY-MM-DD HH:mm")
                        }}~{{
                          moment(item.evaEndTime).format("YYYY-MM-DD HH:mm")
                        }}
                      </div>
                      <div class="module-content-project">
                        <span style="letter-spacing: 4px">承办人：</span>
                        {{ item.purchaseUnderName }}
                      </div>
                      <div
                        class="module-content-project"
                        style="word-break: break-all"
                        :title="item.schemeName"
                      >
                        方案名称：{{ item.schemeName }}
                      </div>
                      <div
                        :title="item.schemeCode"
                        class="module-content-project"
                        style="word-break: break-all"
                      >
                        方案编号：{{ item.schemeCode }}
                      </div>
                      <div class="module-content-hrLine"></div>
                      <span
                        class="module-content-primaryColor"
                        @click="evaluate(index, item)"
                        >{{
                          `进入${
                            item.purchaseType == 1 ||
                            item.purchaseType == 4 ||
                            item.purchaseType == 7 ||
                            item.purchaseType == 8
                              ? "评审"
                              : "评标"
                          }室`
                        }}</span
                      >
                    </div>
                  </template>
                </div>
              </template>
              <div class="clearfix"></div>
            </div>
            <div
              id="ccui-paging"
              v-if="evaluationTableData.length > form.pageSize"
            >
              <el-pagination
                :total="pageTotal"
                :page-size="this.form.pageSize"
                :current-page="this.form.pageNo"
                :page-sizes="[6, 12, 24, 48, 98, 196]"
                background
                layout="total, prev, pager, next, jumper"
                popper-class="ccui-paging-page-size-popper"
                @prev-click="handlePrev"
                @next-click="handleNext"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
              <el-button
                class="ccui-pagination-btn"
                size="mini"
                type="default"
                @click="handleSizeChange('none')"
                >确定</el-button
              >
            </div>
            <div class="clearfix"></div>
          </div>
          <div v-if="isHaveData" class="noDataBox">
            <svg-icon iconClass="noData" class="no-data" />
            <p>暂无数据</p>
          </div>
        </template>
        <template v-if="isActive == 1">
          <listBaseTable
            :tableName="tableName"
            :isIndex="true"
            :data="tableData"
            :pageNo.sync="pageNo"
            :pageSize.sync="pageSize"
            :pageTotal="pageTotal"
            :showOp="false"
            :fixedTableThead="fixedTableThead"
            :unfixedTableThead="unfixedTableThead"
            @handleList="getData"
            border
          >
            <!--            <template slot="op" slot-scope="scope">-->
            <!--              <el-button-->
            <!--                :disabled="scope.row.evaStatus != '2'"-->
            <!--                size="mini"-->
            <!--                type="text"-->
            <!--                ref="listquery-edit-item"-->
            <!--                @click.native.stop="evaluate(scope.$index, scope.row)"-->
            <!--                >评标-->
            <!--              </el-button>-->
            <!--            </template>-->
            <template slot="evaTime" slot-scope="{ row }">
              <span
                >{{ moment(row.evaStartTime).format("YYYY-MM-DD HH:mm") }}~{{
                  moment(row.evaEndTime).format("YYYY-MM-DD HH:mm")
                }}</span
              >
            </template>
          </listBaseTable>
        </template>
        <template v-if="isActive == 2">
          <bidOpeningList
            ref="bidOpeningList"
            @setTotalNum="setTotalNum"
            @viewDetails="viewDetails"
            @viewBid="viewBid"
          />
        </template>
      </div>
    </div>
    <bidOpeningDetail
      v-if="bidOpeningFlag == '1'"
      :baseForm="bidOpeningDetailData"
      @handleBack="handleBack"
    />
    <bidOpeningOpera
      v-if="bidOpeningFlag == '2'"
      :schemeParticipantId="schemeParticipantId"
      @handleBack="handleBack"
    />
    <purchaserAgent
      :initiateVisible.sync="dialogDemanUunit"
      :opUnitId="orgId"
      @setSelectedNode="setSelectedNode"
    ></purchaserAgent>
    <biddingFlow
      :visible.sync="biddingFlowVisible"
      :width="100"
      :key="'biddingFlow' + new Date().getTime()"
    ></biddingFlow>
  </div>
</template>

<script>
import biddingFlow from "@/basa/components/common/biddingFlow";
import purchaserAgent from "@/app/sourceManage/components/purchaserAgent.vue";
import bidOpeningList from "@/app/bidOpening/bidOpeningList.vue";
import bidOpeningDetail from "@/app/bidOpening/bidOpeningDetail.vue";
import bidOpeningOpera from "@/app/bidOpening/bidOpeningOpera.vue";
import { qryPurchaseList } from "@/app/sourceManage/api/expert.js";
import {
  qryExpertEvaProjectListApi,
  dealBidEvaStartApi
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import {
  scpDealBidEvaStartApi,
  checkIsExistExpertProcess
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import moment from "moment";

export default {
  name: "expertEvaluateList",
  components: {
    biddingFlow,
    purchaserAgent,
    bidOpeningList,
    bidOpeningDetail,
    bidOpeningOpera
  },
  data() {
    return {
      moment: moment,
      dialogDemanUunit: false,
      orgId: "",
      // Todo 高级搜索数据 start
      surcingData: {},
      isShow: false,
      biddingFlowVisible: false,
      formData: {
        staffNo: "",
        schemeCode: "",
        schemeName: "",
        purchaseUnder: "",
        evaRoomName: "",
        time: [],
        evaStatus: "2"
      },
      bidOpeningFlag: "0",
      purchaseUnderId: "",
      personOptions: [], // 承办人
      evaStatusOptions: [
        // {
        //   dicValue: "待评标",
        //   dicKey: "1"
        // },
        {
          dicValue: "评标中",
          dicKey: "2"
        },
        {
          dicValue: "评标结束",
          dicKey: "3"
        },
        {
          dicValue: "标书开启",
          dicKey: "4"
        }
      ], // 评标状态
      pageNo: 1,
      colnum: 3,
      pageSize: 10,
      pageTotal: 0,
      evaluationTableData: [],
      tableData: [],
      tabMaxHeight: 300,
      tableMaxHeight: 100,
      tableName: "expertEvaluateList",
      fixedTableThead: [
        {
          label: "序号",
          prop: "id",
          type: "index",
          width: 50,
          title: "id",
          fixed: true
        }
      ],
      unfixedTableThead: [
        { label: "方案编号", prop: "schemeCode", width: 220 },
        {
          label: "方案名称",
          prop: "schemeName",
          minWidth: 180
        },
        { label: "承办人", prop: "purchaseUnderName", width: 100 },
        { label: "评标室", prop: "evaRoomName", width: 220 },
        { label: "评标时间", slot: "evaTime", width: 300 },
        { label: "评标状态", prop: "evaStatusStr", width: 100 }
      ],
      isActive: 0,
      totalNum: 0,
      form: {
        pageNo: 1,
        pageSize: 50
      },
      loading: false,
      width: "",
      todoId: this.$route.query.todoId,
      recordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        width: "0",
        height: "0"
      },
      observer: null,
      firedNum: 0,
      isHaveData: false,
      bidOpeningDetailData: {},
      schemeParticipantId: ""
    };
  },
  watch: {
    biddingFlowVisible: {
      handler(val) {
        this.reComputedWidth();
      },
      immediate: true
    }
  },
  created() {},
  activated() {
    this.isHaveData = false;
  },
  mounted() {
    let _this = this;
    window.addEventListener("message", function(e) {
      if (e.data == false) {
        // 计算宽度
        _this.getData();
      }
    });
    if (window.attachEvent) {
      window.attachEvent("onresize", function(e) {
        if (
          _this.$router.history.current.name === "expertEvaluateList" &&
          _this.biddingFlowVisible === false
        ) {
          // 计算宽度
          if (document.getElementsByClassName("ccui-home-index")[0]) {
            _this.$set(
              _this,
              "width",
              (document.getElementsByClassName("ccui-home-index")[0]
                .offsetWidth -
                86) /
                3 -
                40 +
                "px"
            );
          }
        }
      });
      window.attachEvent("onclick", function(e) {
        if (
          e.srcElement.className == "search-icon-open" ||
          e.srcElement.className == "search-icon-close" ||
          e.srcElement.className == "icon icon-ccui-downdown"
        ) {
          // 计算宽度
          if (document.getElementsByClassName("ccui-home-index")[0]) {
            _this.$set(
              _this,
              "width",
              (document.getElementsByClassName("ccui-home-index")[0]
                .offsetWidth -
                86) /
                3 -
                40 +
                "px"
            );
          }
        }
      });
    } else {
      window.addEventListener("resize", function(e) {
        if (
          _this.$router.history.current.name === "expertEvaluateList" &&
          _this.biddingFlowVisible === false
        ) {
          // 计算宽度
          if (document.getElementsByClassName("ccui-home-index")[0]) {
            _this.$set(
              _this,
              "width",
              (document.getElementsByClassName("ccui-home-index")[0]
                .offsetWidth -
                86) /
                3 -
                40 +
                "px"
            );
          }
        }
      });
      window.addEventListener("click", function(e) {
        if (
          e.target.className == "search-icon-open" ||
          e.target.className == "search-icon-close" ||
          e.target.className == "icon icon-ccui-downdown"
        ) {
          // 计算宽度
          if (document.getElementsByClassName("ccui-home-index")[0]) {
            _this.$set(
              _this,
              "width",
              (document.getElementsByClassName("ccui-home-index")[0]
                .offsetWidth -
                86) /
                3 -
                40 +
                "px"
            );
          }
        }
      });
    }
    // 计算宽度
    this.reComputedWidth();
    // 获取下拉框数据
    this.getDictData();
    if (this.$route.query.type == "bidOpen") {
      this.isActive = 2;
      this.bidOpeningFlag = "2";
      return;
    }
    this.loading = true;
    setTimeout(() => {
      this.getData();
    }, 1500);
    setTimeout(() => {
      if (
        this.$route.query.joinExpertId &&
        this.$route.query.schemeId &&
        this.$route.query.expertRole
      ) {
        this.evaluate(0, {
          schemeId: this.$route.query.schemeId,
          schemeName: this.$route.query.schemeName,
          schemeCode: this.$route.query.schemeCode,
          baseAppId: this.$route.query.baseAppId,
          expertRole: this.$route.query.expertRole,
          joinExpertId: this.$route.query.joinExpertId,
          expertName: this.$route.query.expertName,
          opUnitName: this.$route.query.opUnitName,
          purchaseUnderName: this.$route.query.purchaseUnderName,
          purchaseType: this.$route.query.purchaseType
        });
        return;
      }
    }, 1500);

    if (this.todoId) {
      // 从审批中心过来的，先通过todoid获取评标详情，然后直接进入评标室
      this.qryPurchaseList();
    }
  },
  destroyed() {
    window.removeEventListener("click", () => {});
  },
  methods: {
    qryPurchaseList() {
      let params = {
        joinExpertId: this.todoId
      };
      qryPurchaseList(params).then(res => {
        if (res.data.code == "0") {
          this.evaluate(0, res.data.data);
        }
      });
    },
    reComputedWidth() {
      if (document.getElementsByClassName("ccui-home-index")[0]) {
        this.$set(
          this,
          "width",
          (document.getElementsByClassName("ccui-home-index")[0].offsetWidth -
            86) /
            3 -
            46 +
            "px"
        );
      }
    },
    getDictData() {},
    // 页签跳转
    tabChange(data, index) {
      this.isActive = index;
      this.formData.evaStatus = data;
      this.totalNum = 0;
      this.pageTotal = 0;
      this.tableData = [];
      this.evaluationTableData = [];
      this.resetForm();
      if (this.isActive == 0) {
        this.form.pageNo = 1;
        this.getData();
      } else if (this.isActive == 1) {
        this.pageNo = 1;
        this.pageSize = 10;
        this.getData();
      } else if (this.isActive == 2) {
        this.$nextTick(() => {
          this.$refs.bidOpeningList.resetForm();
        });
      }
      this.reComputedWidth();
    },
    setTotalNum(val) {
      this.totalNum = val;
    },
    viewDetails(data) {
      this.bidOpeningDetailData = data;
      this.bidOpeningFlag = "1";
    },
    viewBid(data) {
      this.schemeParticipantId = data;
      this.bidOpeningFlag = "2";
    },
    handleBack(val) {
      this.bidOpeningFlag = "0";
      if (val == true) {
        this.$refs.bidOpeningList.getListData(this.formData);
      }
    },
    getData() {
      let param = Object.assign({}, this.formData, {
        purchaseUnderId: this.purchaseUnderId,
        isShowPageLoading: true
      });
      if (param.time && param.time.length > 0) {
        param.evaStartTime = param.time[0] + " 00:00:00";
        param.evaEndTime = param.time[1] + " 23:59:59";
      } else {
        param.evaStartTime = "";
        param.evaEndTime = "";
      }
      if (this.isActive == 0) {
        param.pageNo = this.form.pageNo;
        param.pageSize = this.form.pageSize;
        param.evaStatus = "2";
      } else {
        param.pageNo = this.pageNo;
        param.pageSize = this.pageSize;
        param.evaStatus = "3";
      }
      delete param.time;
      param.staffNo = JSON.parse(localStorage.getItem("userInfo")).openId;
      qryExpertEvaProjectListApi(param)
        .then(res => {
          if (res) {
            this.loading = false;
            if (this.isActive == 0) {
              if (res.data.data.rows.length == 0) {
                this.isHaveData = true;
              } else {
                this.isHaveData = false;
              }
              this.evaluationTableData = [];
              for (var i = 0; i < res.data.data.rows.length; i += this.colnum) {
                this.evaluationTableData.push(
                  res.data.data.rows.slice(i, i + this.colnum)
                );
              }
            } else {
              this.tableData = res.data.data.rows;
            }
            this.pageTotal = res.data.data.recordsTotal;
            this.totalNum = res.data.data.recordsTotal;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    flist(arr, n, str) {
      // 补齐数组
      for (var i = arr.length; i < n; i++) {
        arr.push(str);
      }
      return arr;
    },
    showPurchaseUnder() {
      this.orgId =
        JSON.parse(sessionStorage.getItem("userDetal")).orgId == 0
          ? ""
          : JSON.parse(sessionStorage.getItem("userDetal")).orgId + "";
      this.dialogDemanUunit = true;
    },
    setSelectedNode(data, node) {
      this.purchaseUnderId = data.opendId;
      this.formData.purchaseUnder = data.name;
    },
    search(searchData) {
      this.formData = searchData;
      if (this.isActive == 0) {
        this.form.pageNo = 1;
        this.getData();
      } else if (this.isActive == 1) {
        this.pageNo = 1;
        this.getData();
      } else if (this.isActive == 2) {
        this.$refs.bidOpeningList.formData = this.formData;
        this.$refs.bidOpeningList.getListData(this.formData);
      }
    },
    resetForm() {
      this.formData.staffNo = "";
      this.formData.schemeCode = "";
      this.formData.schemeName = "";
      this.formData.purchaseUnder = "";
      this.purchaseUnderId = "";
      this.formData.evaRoomName = "";
      this.formData.time = [];
      if (this.isActive == 0) {
        this.formData.evaStatus = "2";
      } else {
        this.formData.evaStatus = "3";
      }
      if (this.isActive == 0) {
        this.form.pageNo = 1;
      } else {
        this.pageNo = 1;
      }
    },
    handlePrev() {
      if (this.isActive == 0) {
        --this.form.pageNo;
      } else {
        --this.pageNo;
      }
      this.getData();
    },
    handleNext() {
      if (this.isActive == 0) {
        ++this.form.pageNo;
      } else {
        ++this.pageNo;
      }
      this.getData();
    },
    handleSizeChange(val) {
      if (this.isActive == 0) {
        this.form.pageNo = 1;
      } else {
        this.pageNo = 1;
      }
      if (val !== "none") {
        if (this.isActive == 0) {
          this.form.pageSize = val;
        } else {
          this.pageSize = val;
        }
      }
      this.getData();
    },
    handleCurrentChange(val) {
      if (this.isActive == 0) {
        this.form.pageNo = val;
      } else {
        this.pageNo = val;
      }
      this.getData();
    },
    evaluate(index, row) {
      console.log(JSON.stringify(row));
      if (row.supplierFlag === 1) {
        // 分包商
        this.getScpDealBidEvaStartApi(index, row);
      } else {
        // 物采
        this.getDealBidEvaStartApi(index, row);
      }
    },
    getDealBidEvaStartApi(index, row) {
      // 物采判断
      dealBidEvaStartApi({
        schemeId: row.schemeId,
        joinExpertId: row.joinExpertId,
        expertRole: row.expertRole
      }).then(res => {
        if (res) {
          sessionStorage.setItem("expertSourceData", JSON.stringify(row));
          this.biddingFlowVisible = true;
          // let el = document.documentElement;
          // let rfs =
          //   el.requestFullScreen ||
          //   el.webkitRequestFullScreen ||
          //   el.mozRequestFullScreen ||
          //   el.msRequestFullscreen;
          // if (typeof rfs != "undefined" && rfs) {
          //   rfs.call(el);
          // } else
          if (typeof window.ActiveXObject !== "undefined") {
            // eslint-disable-next-line no-undef
            let wscript = new ActiveXObject("WScript.Shell");
            if (wscript != null) {
              wscript.SendKeys("{F11}");
            }
          }
          return false;
        } else {
          this.$message({
            message: "此状态不能进行评标",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      });
    },
    getScpDealBidEvaStartApi(index, row) {
      // 分包商判断
      checkIsExistExpertProcess({
        schemeId: row.schemeId,
        joinExpertId: row.joinExpertId,
        expertRole: row.expertRole
      }).then(res1 => {
        // if (typeof window.ActiveXObject !== "undefined") {
        //   let wscript = new ActiveXObject("WScript.Shell");
        //   if (wscript != null) {
        //     wscript.SendKeys("{F11}");
        //   }
        // }
        if (res1.data.data === "0") {
          scpDealBidEvaStartApi({
            schemeId: row.schemeId,
            bidEvaId: row.bidEvaId,
            joinExpertId: row.joinExpertId,
            expertRole: row.expertRole
          }).then(res => {
            if (res) {
              if (
                row.purchaseType == 1 ||
                row.purchaseType == 4 ||
                row.purchaseType == 7 ||
                row.purchaseType == 8
              ) {
                row.evaStatusStr = "评审中";
              }
              sessionStorage.setItem("expertSourceData", JSON.stringify(row));
              this.biddingFlowVisible = true;
              return false;
            } else {
              this.$message({
                message: "此状态不能进行评标",
                type: "error",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
            }
          });
        } else {
          if (
            row.purchaseType == 1 ||
            row.purchaseType == 4 ||
            row.purchaseType == 7 ||
            row.purchaseType == 8
          ) {
            row.evaStatusStr = "评审中";
          }
          sessionStorage.setItem("expertSourceData", JSON.stringify(row));
          this.biddingFlowVisible = true;
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.ccui-app-container-auto {
  min-height: calc(100vh - 200px);
  margin-bottom: 0;
}
.statisticsCard {
  min-width: 260px;
}

/deep/ .ccui-statistics-card {
  padding: 0;
  min-height: 106px;
}

///deep/ .ccui-multifunctional-table-wrapper .el-table td {
//  border-right: 1px solid #edf2fc;
//}

/deep/
  .ccui-multifunctional-table-wrapper
  .el-table
  .el-table__footer-wrapper
  tbody
  td {
  color: #0089ef;
  text-align: right;
}

/deep/
  .ccui-multifunctional-table-wrapper
  .el-table
  .el-table__footer-wrapper
  tbody
  td:first-child {
  color: #4a4a4a;
  font-weight: 100;
}

///deep/ .ccui-multifunctional-table-wrapper .el-table__header-wrapper th {
//  border-right: 1px solid #edf2fc;
//}

.amountOfmoney {
  display: block;
  text-align: right;
}

/deep/ .el-statistics-card .data-card-tab .content-text .top-number {
  font-size: 26px;
  font-family: Arial-Black, Arial;
}

/deep/ .el-statistics-card .data-card-tab .content-text .newadd span {
  font-family: Arial-Black, Arial;
}

/deep/
  .ccui-multifunctional-table-wrapper
  .el-table
  tbody
  tr
  td:last-child
  .cell {
  padding-left: 10px !important;
}

//.ccui-multifunctional-table-wrapper {
//  padding-bottom: 20px;
//}

.mrlr {
  margin-left: 20px;
  margin-right: 20px;
}

.module-content {
  margin-bottom: -20px;
  .module-content-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .module-content-col {
      background: #ffffff;
      border: 1px solid #e3e3e3;
      margin-bottom: 20px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      width: 326px;
      padding: 20px 20px 22px 20px;
      height: 216px;
      width: calc((100% - 160px) / 3);
      margin-right: 17px;
      .module-content-title {
        height: 38px;
        font-size: 14px;
        color: #4a4a4a;
        letter-spacing: 0;
        text-align: justify;
        line-height: 24px;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .module-content-time {
        height: 17px;
        line-height: 17px;
        font-size: 12px;
        color: #4a4a4a;
        letter-spacing: 0;
        padding: 16px 0 20px;
      }
      .module-content-project {
        height: 22px;
        line-height: 22px;
        font-size: 12px;
        color: #4a4a4a;
        letter-spacing: 0;
        line-height: 22px;
        font-weight: 400;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .module-content-hrLine {
        height: 20px;
        border-bottom: 1px dashed #e3e3e3;
      }
      .module-content-primaryColor {
        padding-top: 15px;
        color: #0089ef;
        line-height: 20px;
        height: 20px;
        font-size: 14px;
        cursor: pointer;
        display: block;
        text-align: center;
      }
    }
    .module-content-col:nth-child(3) {
      margin-right: 0 !important;
    }
  }

  .ccui-paging {
    float: right;
  }
  .svg-time {
    height: 14px;
    width: 14px;
    padding-right: 7px;
  }
}

/deep/ .el-search .ccui-search-wrapper {
  margin-bottom: 20px;
}

/deep/.el-search .el-searchs-bottom .el-searchs-bottom-form .el-row {
  margin: 0 !important;
}

/deep/ .ccui-app-container-auto .el-icon-more {
  position: inherit !important;
  transform: rotate(180deg) !important;
}

/deep/ .el-range-editor.el-input__inner {
  padding-right: 0 !important;
}
.noDataBox {
  background: #f2f2f2;
  width: 366px;
  height: 255px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed #cccccc;
  .no-data {
    width: 88px;
    height: 76px;
  }
  p {
    font-size: 18px;
    color: #999999;
    margin-top: 20px;
    font-family: PingFangSC-Semibold, sans-serif;
  }
}
</style>
